//
//
//
//
//
//
//

import PageMixin from '~/mixins/page'

export default {
  mixins: [PageMixin],
  data () {
    return {
      showFloatingButton: false
    }
  },
  mounted () {
    this.$store.commit('payment/setPaymentType', 'subscription')

    // Hack to fix the fact that starter test price is not loading on first attempt
    const reloaded = localStorage.getItem('reloadedAllG')
    if (reloaded !== 'true') {
      localStorage.setItem('reloadedAllG', 'true')
      setTimeout(function() {
        location.reload()
      }, 3300);
    }
  },
  head () {
    return this.createSeoTags({
      title: this.$t('allGoals.seo.title'),
      description: this.$t('allGoals.seo.description'),
      url: 'https://get-base.com/all-goals',
      link: [
        {
          rel: 'preload',
          as: 'image',
          href: this.getStaticsObject('/home/test_plan_stress.webp')
        },
        {
          rel: 'preload',
          as: 'image',
          href: this.getStaticsObject('/home/test_plan_diet.webp')
        },
        {
          rel: 'preload',
          as: 'image',
          href: this.getStaticsObject('/home/test_plan_sleep.webp')
        }
      ]
    })
  }
}
